/* DC 2026-10-05: ad merchandising pins (Rich's ask, KC's October roadmap).
   ?pin=handle-a,handle-b on any collection URL puts those products first, in that
   order, on page 1 of the main grid. ?style= is read too, matching the Z Supply
   pattern Rich sent. Values are product handles (the last part of the product URL);
   DC variants carry no SKUs. Meta's utm_ and fbclid params are never read or touched.
   Each card comes from sections/dc-pin-card.liquid, so it is the real grid card. A
   handle that 404s (typo, draft, unpublished) is skipped silently. Sorting or
   filtering re-renders the grid without the pins, which is the shopper asking for
   a different order. */
(() => {
  const params = new URLSearchParams(location.search);
  const raw = params.get('pin') || params.get('style');
  if (!raw || Number(params.get('page') || 1) > 1) return;

  const handles = [...new Set(
    raw.split(/[,\s]+/).map((h) => h.trim().toLowerCase()).filter((h) => /^[a-z0-9][a-z0-9-]*$/.test(h))
  )].slice(0, 8);
  if (!handles.length) return;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  const fetchCard = (handle) =>
    fetch(`${root}products/${handle}?section_id=dc-pin-card`)
      .then((res) => (res.ok ? res.text() : ''))
      .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector('product-card'))
      .catch(() => null);

  // Start the requests now, while the page is still parsing.
  const cards = Promise.all(handles.map(fetchCard));

  const apply = async () => {
    const list = document.querySelector('[id$="__main"] product-list');
    if (!list) return;

    const fetched = await cards;
    for (let i = fetched.length - 1; i >= 0; i--) {
      const card = fetched[i];
      if (!card) continue;
      const handle = handles[i];
      list.querySelectorAll(':scope > product-card').forEach((el) => {
        if (el.getAttribute('handle') === handle) el.remove();
      });
      const node = document.importNode(card, true);
      node.setAttribute('data-dc-pinned', '');
      list.prepend(node);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }
})();
